import { useEffect } from "react"
import { useParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetSeedTicketTypeList = () => {
    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()
    const { idx } = useParams()

    useEffect(() => {
        fetchRequest("GET", `/admin/event/${idx}/seed-ticket-type/list`)
    }, [])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 404:
                setAlert("대회 시리즈 데이터가 존재하지 않습니다.")
                break
        }
    })

    return [fetchResult]
}

export default useGetSeedTicketTypeList